module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "intro-y box mt-6"
  }, [_c('div', {
    staticClass: "flex flex-col sm:flex-row items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n        Editar Tarea - "), _c('app-title-custom')], 1), _vm._v(" "), _c('div', {
    staticClass: "form-check w-full sm:w-auto sm:ml-auto mt-3 sm:mt-0"
  }, [_vm._v("\n        Creada por:\n        "), _c('label', {
    staticClass: "form-check-label ml-0 sm:ml-2",
    attrs: {
      "for": "show-example-1"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.task_current.user_created_name) + " - " + _vm._s(_vm.task_current.created_at) + "\n        ")])])]), _vm._v(" "), _c('form', {
    staticClass: "form-task",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateTask()
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Nombre:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task_current.name),
      expression: "task_current.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": "",
      "disabled": ![1].includes(_vm.usersession.role)
    },
    domProps: {
      "value": (_vm.task_current.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task_current, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-3"
  }, [_c('label', [_vm._v("Fecha de entrega:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task_current.date),
      expression: "task_current.date"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "date",
      "required": "",
      "disabled": _vm.usersession.role == 4 || _vm.task_current.state_id == 4
    },
    domProps: {
      "value": (_vm.task_current.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task_current, "date", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.usersession.role == 4) ? _c('div', {
    staticClass: "col-span-12 sm:col-span-3"
  }, [_c('label', [_vm._v("Horas:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task_current.hours),
      expression: "task_current.hours"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "number",
      "required": "",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.task_current.hours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task_current, "hours", $event.target.value)
      }
    }
  })]) : _c('div', {
    staticClass: "col-span-12 sm:col-span-3"
  }, [_c('label', [_vm._v("Horas:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task_current.hours),
      expression: "task_current.hours"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    class: _vm.task_current.state_id == 4 ? 'cursor-not-allowed' : '',
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100",
      "step": ".01",
      "required": "",
      "disabled": _vm.task_current.state_id == 4
    },
    domProps: {
      "value": (_vm.task_current.hours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task_current, "hours", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12 xxl:col-span-12"
  }, [_c('label', [_vm._v("Descripcion")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task_current.description),
      expression: "task_current.description"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "rows": "5",
      "disabled": ![1].includes(_vm.usersession.role)
    },
    domProps: {
      "value": (_vm.task_current.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task_current, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.task_current.campaign_attribute) ? _c('div', {
    staticClass: "col-span-12 sm:col-span-3"
  }, [_c('label', [_vm._v("Proyecto")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task_current.campaign_attribute.project_name),
      expression: "task_current.campaign_attribute.project_name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": "",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.task_current.campaign_attribute.project_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task_current.campaign_attribute, "project_name", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.task_current.campaign_attribute) ? _c('div', {
    staticClass: "col-span-12 sm:col-span-3"
  }, [_c('label', [_vm._v("Campaña")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task_current.campaign_attribute.name),
      expression: "task_current.campaign_attribute.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": "",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.task_current.campaign_attribute.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task_current.campaign_attribute, "name", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.usersession.role == 4) ? _c('div', {
    staticClass: "col-span-12 sm:col-span-3"
  }, [_c('label', [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task_current.state_id),
      expression: "task_current.state_id"
    }],
    staticClass: "input w-full border mt-2",
    class: _vm.task_current.state_id == 4 ? 'bg-disabled' : '',
    attrs: {
      "disabled": _vm.task_current.state_id == 4,
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.task_current, "state_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el estado...")]), _vm._v(" "), _vm._l((_vm.filteredStates), function(state) {
    return _c('option', {
      domProps: {
        "value": state.id
      }
    }, [_vm._v("\n              " + _vm._s(state.name) + "\n            ")])
  })], 2)]) : _c('div', {
    staticClass: "col-span-12 sm:col-span-3"
  }, [_c('label', [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task_current.state_id),
      expression: "task_current.state_id"
    }],
    staticClass: "input w-full border mt-2",
    class: _vm.task_current.state_id == 4 ? 'bg-disabled' : '',
    attrs: {
      "disabled": _vm.task_current.state_id == 4,
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.task_current, "state_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el estado...")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      attrs: {
        "disabled": ![4].includes(state.id) &&
          _vm.usersession.team_id != _vm.task_current.team_id
      },
      domProps: {
        "value": state.id
      }
    }, [_vm._v("\n              " + _vm._s(state.name) + "\n            ")])
  })], 2)]), _vm._v(" "), (_vm.usersession.team_id == this.team_session) ? _c('div', {
    staticClass: "col-span-12 sm:col-span-3"
  }, [_c('label', [_vm._v("Usuario")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task_current.user_id),
      expression: "task_current.user_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    class: _vm.task_current.state_id == 4 ? 'bg-disabled' : '',
    attrs: {
      "disabled": _vm.task_current.state_id == 4,
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.task_current, "user_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el usuario")]), _vm._v(" "), _vm._l((_vm.filteredUsers), function(user) {
    return [([2, 3, 4, 5].includes(user.roles[0].id)) ? _c('option', {
      key: user.id,
      domProps: {
        "value": user.id
      }
    }, [_vm._v("\n                " + _vm._s(user.name) + "\n              ")]) : _vm._e()]
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.task_current.path) ? _vm._l((_vm.task_current.path.split(',')), function(path, key) {
    return _c('div', {
      staticClass: "relative col-span-12 sm:col-span-4"
    }, [_c('label', [_vm._v("Url " + _vm._s(key + 1))]), _vm._v(" "), _c('input', {
      staticClass: "input w-full border mt-2 flex-1",
      attrs: {
        "type": "text",
        "disabled": ""
      },
      domProps: {
        "value": path
      }
    }), _vm._v(" "), (path) ? _c('div', {
      staticClass: "absolute top-0 right-0 mt-28 rounded-r w-10 h-10 flex items-center justify-center bg-gray-100 border text-gray-600"
    }, [_c('a', {
      attrs: {
        "href": path,
        "target": "_blank"
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "link",
        "classname": "w-4 h-4"
      }
    })], 1)]) : _vm._e()])
  }) : _vm._e(), _vm._v(" "), ([3, 4, 5, 6, 7].includes(_vm.task_current.state_id)) ? _c('div', {
    staticClass: "col-span-12 gap-4 grid grid-cols-12 py-5 row-gap-3 sm:col-span-12 bg-gray-300 px-3 rounded"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Descripcion Respuesta")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task_current.response_observations),
      expression: "task_current.response_observations"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "rows": "3",
      "required": "",
      "disabled": _vm.task_current.state_id == 6 ||
        _vm.task_current.state_id == 4 ||
        _vm.usersession.team_id != _vm.task_current.team_id
    },
    domProps: {
      "value": (_vm.task_current.response_observations)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task_current, "response_observations", $event.target.value)
      }
    }
  })]), _vm._v(" "), (!_vm.edit_response_path) ? [_c('p', {
    staticClass: "relative col-span-12 sm:col-span-12"
  }, [_vm._v("\n              Urls Respuesta\n              "), (_vm.task_current.state_id != 4) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.editResponsePath()
      }
    }
  }, [_vm._v("- Editar")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.task_current.response_path), function(path, key) {
    return _c('div', {
      staticClass: "relative col-span-12 sm:col-span-12"
    }, [_c('label', [_vm._v("Url Respuesta " + _vm._s(key + 1))]), _vm._v(" "), _c('input', {
      staticClass: "input w-full border mt-2 flex-1",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": path
      }
    }), _vm._v(" "), (path) ? _c('div', {
      staticClass: "absolute top-0 right-0 mt-28 rounded-r w-10 h-10 flex items-center justify-center bg-gray-100 border text-gray-600"
    }, [_c('a', {
      attrs: {
        "href": path,
        "target": "_blank"
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "link",
        "classname": "w-4 h-4"
      }
    })], 1)]) : _vm._e()])
  })] : [_c('div', {
    staticClass: "relative col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Url Archivo Respuesta (opcional)")]), _vm._v(" "), _c('MultiSelect', {
    staticClass: "mt-2",
    attrs: {
      "options": _vm.responsePathOptions,
      "multiple": true,
      "taggable": true,
      "disabled": _vm.task_current.state_id == 6 ||
        _vm.task_current.state_id == 4 ||
        _vm.usersession.team_id != _vm.task_current.team_id
    },
    on: {
      "tag": _vm.addResponseTag
    },
    model: {
      value: (_vm.response_path),
      callback: function($$v) {
        _vm.response_path = $$v
      },
      expression: "response_path"
    }
  })], 1)]], 2) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('closeEditTask')
      }
    }
  }, [_vm._v("\n          Cancelar\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "button bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create",
      "disabled": _vm.buttonIsLoading
    }
  }, [(_vm.buttonIsLoading) ? [_vm._v(" Cargando... ")] : [_vm._v(" Modificar ")]], 2)])]), _vm._v(" "), _c('h4', {
    staticClass: "ml-6 font-bold text-sm pb-2"
  }, [_vm._v("Listado de Versiones")]), _vm._v(" "), _c('hr', {
    staticClass: "mx-5"
  }), _vm._v(" "), _c('TaskEditVersions', {
    attrs: {
      "users": _vm.users,
      "states": _vm.states,
      "usersession": _vm.usersession,
      "task_current": _vm.task_current,
      "team_session": _vm.team_session
    }
  }), _vm._v(" "), (!_vm.createVersionVariable) ? _c('div', {
    staticClass: "border-b border-gray-200 flex flex-col items-center p-5 sm:flex-row"
  }, [_c('button', {
    staticClass: "button bg-theme-1 text-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.createVersionVariable = true
      }
    }
  }, [_vm._v("\n        Crear Nueva Version\n      ")])]) : _c('form', {
    staticClass: "intro-y grid grid-cols-12 gap-3 p-5 form-task",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createVersion()
      }
    }
  }, [_c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Descripcion")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.version.observations),
      expression: "version.observations"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "rows": "5",
      "required": ""
    },
    domProps: {
      "value": (_vm.version.observations)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.version, "observations", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_c('label', [_vm._v("Fecha")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.version.date),
      expression: "version.date"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "date",
      "required": ""
    },
    domProps: {
      "value": (_vm.version.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.version, "date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("Url Archivo (opcional)")]), _vm._v(" "), _c('MultiSelect', {
    staticClass: "mt-2",
    attrs: {
      "options": _vm.options,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.version.path),
      callback: function($$v) {
        _vm.$set(_vm.version, "path", $$v)
      },
      expression: "version.path"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-8 col-span-3 sm:col-span-3"
  }, [_c('button', {
    staticClass: "button bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "createversion",
      "disabled": _vm.buttonIsLoading
    }
  }, [(_vm.buttonIsLoading) ? [_vm._v(" Cargando... ")] : [_vm._v(" Confirmar Nueva Version ")]], 2)])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db49bada","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/task/TaskEditModal.vue
// module id = 478
// module chunks = 1